export const STORAGE_URL = 'https://z4l1g0tev5tfrvnx.public.blob.vercel-storage.com';
export const BASE_URL = 'https://www.ktebstan.net';
